export enum FreightTerm {
    Prepaid = "Prepaid",
    ThirdParty = "ThirdParty",
    Collect = "Collect",
}
